var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHalfTights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.714 6.286h20.572V3.714H3.714zM19.143 11.773L24.286 14V7.143h-5.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.822 11.161a.448.448 0 01-.22-.385V7.143H7.443v3.633c0 .171-.088.3-.22.385l-3.509 2.095v6.37l1.228 4.66h6.755l2.326-12.313 2.28 12.313h6.755l1.228-4.66v-6.413l-3.464-2.052z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.857 7.143H3.714v7.714l5.143-2.593z"
  }))));
}

export default SvgHalfTights;